import { render, staticRenderFns } from "./webSiteCreateTwo.vue?vue&type=template&id=8c50174e&scoped=true"
import script from "./webSiteCreateTwo.vue?vue&type=script&lang=js"
export * from "./webSiteCreateTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c50174e",
  null
  
)

export default component.exports